export default __webpack_public_path__ + "static/media/money-back.9d76906b.svg";